<template>
  <base-list-layout :title="'Source Overall'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="3rem">
        <el-form-item label="Source">
          <group-select
            v-model="filter.sourceIds"
            :data-source="sourcesList"
            multiple
            :loading="sourceLoading"
            clearable
            reserve-keyword
            filterable
            placeholder="请选择"
          />
        </el-form-item>
        <el-form-item label="Source Status">
          <el-select v-model="filter.enable">
            <el-option
              v-for="item in SourceConstants.sourceStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Source PayoutType">
          <el-select v-model="filter.payoutType" clearable>
            <el-option
              v-for="item in SourceConstants.payoutTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Source Name">
          <el-input v-model="filter.company" placeholder="hypertap"></el-input>
        </el-form-item>
        <el-form-item label="PM Name">
          <el-input v-model="filter.pmName" />
        </el-form-item>
        <el-form-item label="BD Name">
          <el-input v-model="filter.bdName" />
        </el-form-item>
        <el-form-item label="Company Platform">
          <el-input v-model="filter.companyPlatform" />
        </el-form-item>
        <el-form-item label="Company Entity">
          <el-input v-model="filter.companyEntity" />
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" style="width:2rem" @click="searchListClick(1)">Search </el-button>
      <el-button type="primary" style="width:2rem" icon="el-icon-plus" @click="createClick"
        >Create
      </el-button>
    </template>
    <template #table>
      <el-table v-loading="listLoading" highlight-current-row :data="dataList">
        <el-table-column label="Id" prop="id" min-width="120" align="center" fixed="left">
          <template slot-scope="scope">
            <span
              @click="detailClick(scope.row)"
              v-bind:class="{ cor337ab7: scope.row.noRedirect !== 1 }"
              >{{ scope.row.id }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="Name" prop="company" align="center" min-width="180" fixed="left">
          <template slot-scope="scope">
            <span
              @click="detailClick(scope.row)"
              v-bind:class="{ cor337ab7: scope.row.noRedirect !== 1 }"
              >{{ scope.row.company }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          align="center"
          show-overflow-tooltip
          min-width="180"
        />
        <el-table-column label="SignName" prop="signName" align="center" min-width="160" />
        <el-table-column
          label="Company Platform"
          prop="companyPlatform"
          show-overflow-tooltip
          align="center"
          min-width="190"
        >
          <template #default="scope">
            <el-popover trigger="click">
              <el-descriptions :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Name
                  </template>
                  {{ scope.row.bankName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Address
                  </template>
                  {{ scope.row.bankAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Number
                  </template>
                  {{ scope.row.bankAccountNumber }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Name
                  </template>
                  {{ scope.row.bankAccountName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Swift Code
                  </template>
                  {{ scope.row.swiftCode }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Branch Code
                  </template>
                  {{ scope.row.branchCode }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button type="text" slot="reference">{{ scope.row.companyPlatform }} </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Company Entity"
          prop="companyEntity"
          align="center"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column label="Invoice information" align="center" min-width="190">
          <template #default="scope">
            <el-popover trigger="click">
              <el-descriptions :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Company Name En
                  </template>
                  {{ scope.row.companyNameEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address
                  </template>
                  {{ scope.row.companyAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address En
                  </template>
                  {{ scope.row.companyAddressEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Postal Code
                  </template>
                  {{ scope.row.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Phone
                  </template>
                  {{ scope.row.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Brn
                  </template>
                  {{ scope.row.brn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Tin
                  </template>
                  {{ scope.row.tin }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button type="text" slot="reference"
                >{{
                  scope.row.companyNameEn === undefined
                    ? scope.row.companyEntity
                    : scope.row.companyNameEn
                }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="PM Name" prop="pmName" align="center" min-width="150" />
        <el-table-column label="BD Name" prop="bdName" align="center" min-width="150" />
        <el-table-column label="Status" prop="enable" align="center" />
        <el-table-column
          label="Whitelist Limited"
          prop="whitelistLimited"
          align="center"
          min-width="140"
        />
        <el-table-column label="Weightiness" prop="weightiness" align="center" min-width="105">
          <template slot-scope="scope">
            <span v-if="scope.row.weightiness <= 5">只测一次单</span>
            <span v-else-if="scope.row.weightiness >= 6">正常测单</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Description"
          prop="description"
          align="center"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column label="TimeZone" prop="timeZone" align="center" min-width="100" />
        <el-table-column label="Traffic Type" prop="level" align="center" min-width="100">
          <template #default="scope">
            {{ getTrafficType(scope.row.level) }}
          </template>
        </el-table-column>
        <el-table-column label="Traffic Tag" prop="trafficTag" align="center" min-width="100" />
        <el-table-column label="SyncUrl" min-width="140" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <a style="color:#606266;" target="_blank" :href="scope.row.syncUrl"
              ><span>{{ scope.row.syncUrl }}</span></a
            >
          </template>
        </el-table-column>
        <el-table-column label="PayoutType" prop="payoutType" min-width="120" />
        <el-table-column label="MaxPullOffer" prop="pullOfferMaxRecord" min-width="120" />
        <el-table-column label="Account Name" prop="createBy" min-width="120" />
        <el-table-column
          label="Time"
          prop="createTime"
          align="center"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column label="Action" align="center" min-width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="updateClick(scope.row)">Update </el-button>
            <el-button @click="openSourceUser(scope.row)">UserSource</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pageSize"
        :currentPage="currentPage"
      />
    </template>
    <template #dialog>
      <el-dialog
        :visible.sync="userDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
      >
        <el-transfer
          filterable
          :titles="['Authorizable', 'Authorised']"
          v-model="sourceUserList"
          :data="allUser"
        ></el-transfer>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="authSourceUser()">确 定</el-button>
        </span>
      </el-dialog>
      <SourceCommonForm
        :dialog-type="dialogType"
        :dialog-visible.sync="dialogVisible"
        :update-data="updateData"
        @refresh-list="searchListClick"
      />
    </template>
  </base-list-layout>
</template>
<script>
  import { getSourceList, updateSourceUser, getSourceUserList } from 'api/source/overall';
  import { getUserList } from 'api/user';
  import { myMixin } from '@/mixins/mixins.js';
  import Pagination from '@/components/pagination';
  import { mapState, mapActions } from 'vuex';
  import { cloneDeep } from 'lodash-es';
  import GroupSelect from '@/components/GroupSelect';
  import SourceCommonForm from '@/views/source/forms/SourceBaseForm.vue';
  import { getTrafficType, SourceConstants } from '@/assets/js/constants';
  import { getCompanyInfoList } from 'api/common/companyInfo';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';

  let clickTimer = null;
  const defaultSource = {
    sourceName: '',
    weightiness: '',
    description: '',
    trafficType: '',
    payoutType: 'CPA',
    timeZone: '',
    trafficTag: [],
    level: '',
    bindAccountId: '',
    companyPlatform: '',
    companyEntity: '',
    syncUrl: '',
    signName: '',
    pmId: '',
    pmName: '',
    bdId: '',
    bdName: '',
    bfiId: null,
    bfbId: null,
  };
  export default {
    name: 'SourceOverall',
    mixins: [myMixin],
    components: {
      BaseListLayout,
      SourceCommonForm,
      Pagination,
      GroupSelect,
    },
    data() {
      return {
        pageSize: 10,
        currentPage: 1,
        filter: {
          sourceIds: null,
          company: null,
          pmName: null,
          bdName: null,
          companyPlatform: null,
          companyEntity: null,
          payoutType: '',
          enable: 'enable',
        },
        source: Object.assign({}, defaultSource),
        addWhitelistLimited: [
          {
            label: 'YES',
            value: 'YES',
          },
          {
            label: 'NO',
            value: 'NO',
          },
        ],
        companyInfoList: [],
        listLoading: false,
        total: null,
        bindAccountList: [],
        dialogType: 'new',
        updateData: {},
        dialogVisible: false,
        dataList: [],
        tagOption: [],
        userDialogVisible: false,
        sourceUserList: [],
        allUser: [],
        sourceId: '',
      };
    },
    computed: {
      SourceConstants() {
        return SourceConstants;
      },
      ...mapState('source', {
        sourcesList: (state) => state.sourcesList,
        sourceLoading: (state) => state.sourceLoading,
      }),
    },
    mounted() {
      this.searchListClick();
      this.getSourceIdsList();
      this.getCompanyInfo();
    },
    methods: {
      getTrafficType,
      ...mapActions('source', ['getSourceIdsList']),
      getCompanyInfo() {
        getCompanyInfoList({}).then((res) => {
          if (res) {
            const result = res.result;
            this.companyInfoList = result.dataList;
          }
        });
      },
      searchListClick(curPage) {
        this.listLoading = true;
        if (curPage) {
          this.currentPage = curPage;
        }
        let param = {
          ...this.filter,
          page: this.currentPage,
          pageSize: this.pageSize,
        };
        if (param.sourceIds && Array.isArray(param.sourceIds)) {
          param.sourceIds = param.sourceIds.join(',');
        }
        getSourceList(param).then((response) => {
          this.listLoading = false;
          if (response.code === 200) {
            this.dataList = response.result.dataList;
            this.total = response.total;
          } else {
            this.$message.error(response.message);
          }
        });
      },
      updateClick(row) {
        const source = cloneDeep(row);
        source.sourceName = source.company;
        source.trafficTag = source.trafficTag ? source.trafficTag.split(',') : [];
        this.source = source;
        this.dialogType = 'edit';
        this.updateData = source;
        if (this.updateData.bfbId === undefined) {
          this.updateData.bfbId = null;
        }
        if (this.updateData.bfiId === undefined) {
          this.updateData.bfiId = null;
        }
        this.dialogVisible = true;
      },
      createClick() {
        this.source = Object.assign({}, defaultSource);
        this.dialogType = 'new';
        this.updateData = {
          bfiId: null,
          bfbId: null,
        };
        this.dialogVisible = true;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchListClick();
      },
      detailClick(row) {
        if (clickTimer) {
          window.clearTimeout(clickTimer);
          clickTimer = null;
        }
        if (row.noRedirect === 1) {
          return false;
        }
        var that = this;
        clickTimer = window.setTimeout(function() {
          that.$nextTick(() => {
            const { href } = that.$router.resolve({
              path: '/source/detail',
              query: {
                sourceId: row.id,
                sourceName: row.company,
              },
            });
            window.open(href, '_blank');
          });
        }, 300);
      },
      async getAllUser() {
        const { code, result = [] } = await getUserList();
        if (code) {
          this.allUser = result.map((item) => ({
            key: item.id,
            label: item.uname,
            title: item.uname,
          }));
        }
      },
      async getSourceUsers(sourceId) {
        const { code, result = [] } = await getSourceUserList(sourceId);
        if (code === 200) {
          this.sourceUserList = result.map((item) => item.id);
        } else {
          this.$message.error('Failed to get authorized list');
        }
      },
      openSourceUser(row) {
        this.sourceId = row.id;
        this.getAllUser();
        this.getSourceUsers(row.id);
        this.userDialogVisible = true;
      },
      async authSourceUser() {
        const params = {
          sourceId: this.sourceId,
          accountList: this.sourceUserList,
        };
        const { code, message } = await updateSourceUser(params);
        if (code === 200) {
          this.$message.success({
            message: 'Update Success',
            type: 'success',
          });
          this.userDialogVisible = false;
        } else {
          this.$message.error('Update Error:' + message);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .cor337ab7 {
    color: #337ab7;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  ::v-deep .el-transfer {
    display: flex;
    justify-content: center;
    align-items: center;

    .el-transfer-panel {
      width: 288px !important;
    }
  }
</style>
